<mat-card-content>
  <div id="containerInst"></div>
  <div class="center-container">
    <small class="subitutlo-simpli">*Tasas correspondientes al plazo de la inversión, anualizada.</small>
  </div>
</mat-card-content>